// src/utils/dialog.js
import { ref } from 'vue'

const dialogRef = ref(null)

export const registerDialog = (refInstance) => {
  dialogRef.value = refInstance
}

/**
 * Wyświetla modal typu Alert z automatycznym odliczaniem
 */
export const showAlert = (message, options = {}) => {
  if (!dialogRef.value) return Promise.resolve()
  
  return dialogRef.value.show({
    type: 'alert',
    message,
    title: options.title || 'Informacja',
    icon: options.icon || 'bi-info-circle text-primary',
    confirmText: options.confirmText || 'OK',
    confirmClass: options.confirmClass || 'btn-primary',
    duration: options.duration ?? 5000 // Domyślnie 5 sekund (można przekazać np. 0 aby wyłączyć)
  })
}

/**
 * Wyświetla modal typu Confirm (bez timera)
 */
export const showConfirm = (message, options = {}) => {
  if (!dialogRef.value) return Promise.resolve(false)

  return dialogRef.value.show({
    type: 'confirm',
    message,
    title: options.title || 'Potwierdzenie',
    icon: options.icon || 'bi-exclamation-triangle text-warning',
    confirmText: options.confirmText || 'Tak',
    cancelText: options.cancelText || 'Anuluj',
    confirmClass: options.confirmClass || 'btn-danger'
  })
}

export const webAlert = (data, loadingRef = null) => {
    // 1. Opcjonalnie zdejmij loader od razu przed wywołaniem alertu
    if (loadingRef && 'value' in loadingRef) {
        loadingRef.value = false
    }

    // 2. Krótkie opóźnienie, aby domknęły się inne modale / zniknął loader
    setTimeout(async () => {
        const isString = typeof data === 'string'
        const isSuccess = data?.status === 'success' || data?.type === 'success' || data?.success === true
        const title = isSuccess ? 'Sukces' : 'Błąd'
        const icon = isSuccess ? 'bi-check-circle text-success' : 'bi-x-circle text-danger'
        const message = isString 
            ? data 
            : (data?.message || (isSuccess ? 'Operacja zakończona sukcesem.' : 'Wystąpił błąd.'))

        await showAlert(message, {
            title,
            icon
        })
    }, 150)
}


export const errorLoading = () => {
    setTimeout(async () => {
        await showAlert('Błąd podczas odczytu / zapisu danych z serwera.', {
            title: 'Błąd połączenia',
            icon: 'bi-x-circle text-danger'
        })
    }, 150)
}